import Snippet from './snippet';
export default Snippet;